<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { MESSAGE_ACTION_MODES } from 'dashboard/components/widgets/WootWriter/constants';
import MessagePreview from 'dashboard/components/widgets/conversation/MessagePreview.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  message: {
    type: Object,
    required: true,
  },
  mode: {
    type: String,
    required: true,
    validator: val => Object.values(MESSAGE_ACTION_MODES).includes(val),
  },
});

const emit = defineEmits(['dismiss']);

const { t } = useI18n();

const isEditMode = computed(() => {
  return props.mode === MESSAGE_ACTION_MODES.EDIT;
});

const bannerTitle = computed(() => {
  return isEditMode.value
    ? t('CONVERSATION.REPLYBOX.EDITING')
    : t('CONVERSATION.REPLYBOX.REPLYING_TO');
});

const bannerIcon = computed(() => {
  return isEditMode.value ? 'edit' : 'arrow-reply';
});
</script>

<template>
  <div
    class="reply-editor bg-n-slate-9/10 rounded-md py-1 pl-2 pr-1 text-xs tracking-wide mt-2 flex items-center gap-1.5 -mx-2"
  >
    <fluent-icon class="flex-shrink-0 icon" :icon="bannerIcon" size="14" />
    <div class="flex-grow gap-1 mt-px text-xs truncate">
      {{ bannerTitle }}
      <MessagePreview
        :message="message"
        :show-message-type="false"
        :default-empty-message="$t('CONVERSATION.REPLY_MESSAGE_NOT_FOUND')"
        class="inline"
      />
    </div>
    <Button
      v-tooltip="$t('CONVERSATION.REPLYBOX.DISMISS_REPLY')"
      ghost
      xs
      slate
      icon="i-lucide-x"
      @click.stop="emit('dismiss')"
    />
  </div>
</template>

<style lang="scss">
// TODO: Remove this
// override for dashboard/assets/scss/widgets/_reply-box.scss
.reply-editor {
  .icon {
    margin-right: 0px !important;
  }
}
</style>
